import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateProductionTriggerMutationVariables = Types.Exact<{
  input: Types.CreateProductionTriggerInput;
}>;


export type CreateProductionTriggerMutation = { __typename?: 'Mutation', createProductionTrigger: { __typename?: 'ProductionTriggerPayload', productionTrigger?: { __typename?: 'ProductionTriggerStateData', tenantId: string, productionTriggerId: string, name: string, source: Types.ProductionTriggerSource, unit: Types.ProductionTriggerUnit, offset: number, expireBy?: Types.TDateISO | null, status: Types.ProductionTriggerStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProductionTriggerMutationVariables = Types.Exact<{
  input: Types.UpdateProductionTriggerInput;
}>;


export type UpdateProductionTriggerMutation = { __typename?: 'Mutation', updateProductionTrigger: { __typename?: 'ProductionTriggerPayload', productionTrigger?: { __typename?: 'ProductionTriggerStateData', tenantId: string, productionTriggerId: string, name: string, source: Types.ProductionTriggerSource, unit: Types.ProductionTriggerUnit, offset: number, expireBy?: Types.TDateISO | null, status: Types.ProductionTriggerStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateProductionTriggerMutationVariables = Types.Exact<{
  input: Types.ActivateProductionTriggerInput;
}>;


export type ActivateProductionTriggerMutation = { __typename?: 'Mutation', activateProductionTrigger: { __typename?: 'ProductionTriggerPayload', productionTrigger?: { __typename?: 'ProductionTriggerStateData', tenantId: string, productionTriggerId: string, name: string, source: Types.ProductionTriggerSource, unit: Types.ProductionTriggerUnit, offset: number, expireBy?: Types.TDateISO | null, status: Types.ProductionTriggerStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type InactivateProductionTriggerMutationVariables = Types.Exact<{
  input: Types.InactivateProductionTriggerInput;
}>;


export type InactivateProductionTriggerMutation = { __typename?: 'Mutation', inactivateProductionTrigger: { __typename?: 'ProductionTriggerPayload', productionTrigger?: { __typename?: 'ProductionTriggerStateData', tenantId: string, productionTriggerId: string, name: string, source: Types.ProductionTriggerSource, unit: Types.ProductionTriggerUnit, offset: number, expireBy?: Types.TDateISO | null, status: Types.ProductionTriggerStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteProductionTriggerMutationVariables = Types.Exact<{
  input: Types.DeleteProductionTriggerInput;
}>;


export type DeleteProductionTriggerMutation = { __typename?: 'Mutation', deleteProductionTrigger: { __typename?: 'ProductionTriggerPayload', productionTrigger?: { __typename?: 'ProductionTriggerStateData', tenantId: string, productionTriggerId: string, name: string, source: Types.ProductionTriggerSource, unit: Types.ProductionTriggerUnit, offset: number, expireBy?: Types.TDateISO | null, status: Types.ProductionTriggerStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateProductionTriggerDocument = new TypedDocumentString(`
    mutation CreateProductionTrigger($input: CreateProductionTriggerInput!) {
  createProductionTrigger(input: $input) {
    productionTrigger {
      ...ProductionTriggerDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTriggerDetails on ProductionTriggerStateData {
  tenantId
  productionTriggerId
  name
  source
  unit
  offset
  expireBy
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}`);
export const UpdateProductionTriggerDocument = new TypedDocumentString(`
    mutation UpdateProductionTrigger($input: UpdateProductionTriggerInput!) {
  updateProductionTrigger(input: $input) {
    productionTrigger {
      ...ProductionTriggerDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTriggerDetails on ProductionTriggerStateData {
  tenantId
  productionTriggerId
  name
  source
  unit
  offset
  expireBy
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}`);
export const ActivateProductionTriggerDocument = new TypedDocumentString(`
    mutation ActivateProductionTrigger($input: ActivateProductionTriggerInput!) {
  activateProductionTrigger(input: $input) {
    productionTrigger {
      ...ProductionTriggerDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTriggerDetails on ProductionTriggerStateData {
  tenantId
  productionTriggerId
  name
  source
  unit
  offset
  expireBy
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}`);
export const InactivateProductionTriggerDocument = new TypedDocumentString(`
    mutation InactivateProductionTrigger($input: InactivateProductionTriggerInput!) {
  inactivateProductionTrigger(input: $input) {
    productionTrigger {
      ...ProductionTriggerDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTriggerDetails on ProductionTriggerStateData {
  tenantId
  productionTriggerId
  name
  source
  unit
  offset
  expireBy
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}`);
export const DeleteProductionTriggerDocument = new TypedDocumentString(`
    mutation DeleteProductionTrigger($input: DeleteProductionTriggerInput!) {
  deleteProductionTrigger(input: $input) {
    productionTrigger {
      ...ProductionTriggerDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTriggerDetails on ProductionTriggerStateData {
  tenantId
  productionTriggerId
  name
  source
  unit
  offset
  expireBy
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateProductionTrigger: build.mutation<CreateProductionTriggerMutation, CreateProductionTriggerMutationVariables>({
      query: (variables) => ({ document: CreateProductionTriggerDocument, variables })
    }),
    UpdateProductionTrigger: build.mutation<UpdateProductionTriggerMutation, UpdateProductionTriggerMutationVariables>({
      query: (variables) => ({ document: UpdateProductionTriggerDocument, variables })
    }),
    ActivateProductionTrigger: build.mutation<ActivateProductionTriggerMutation, ActivateProductionTriggerMutationVariables>({
      query: (variables) => ({ document: ActivateProductionTriggerDocument, variables })
    }),
    InactivateProductionTrigger: build.mutation<InactivateProductionTriggerMutation, InactivateProductionTriggerMutationVariables>({
      query: (variables) => ({ document: InactivateProductionTriggerDocument, variables })
    }),
    DeleteProductionTrigger: build.mutation<DeleteProductionTriggerMutation, DeleteProductionTriggerMutationVariables>({
      query: (variables) => ({ document: DeleteProductionTriggerDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateProductionTriggerMutation, useUpdateProductionTriggerMutation, useActivateProductionTriggerMutation, useInactivateProductionTriggerMutation, useDeleteProductionTriggerMutation } = injectedRtkApi;
